import { useState } from "react";
import { BellRing, Check, Loader2 } from "lucide-react";
import { newsApi } from "./newsUtils";

const errText = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d?.message === "string") return d.message;
  if (Array.isArray(d)) return "Please enter a valid email address.";
  return "Something went wrong. Please try again.";
};

export const ReminderForm = ({ slug }) => {
  const [form, setForm] = useState({ name: "", email: "", hp: "" });
  const [status, setStatus] = useState({});
  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading" });
    try {
      await newsApi.post(`/${encodeURIComponent(slug)}/remind`, form);
      setStatus({ state: "done" });
    } catch (err) {
      setStatus({ state: "error", msg: errText(err) });
    }
  };
  if (status.state === "done") {
    return (
      <p className="mt-5 flex items-start gap-2 border-t border-navy/10 pt-5 text-sm text-navy" role="status" data-testid="reminder-success">
        <Check size={17} className="mt-0.5 shrink-0 text-gold-deep" aria-hidden="true" />
        You're signed up. Check your inbox for a confirmation. We'll email a reminder the morning before the event.
      </p>
    );
  }
  return (
    <form onSubmit={submit} className="mt-5 border-t border-navy/10 pt-5" data-testid="reminder-form">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-slate"><BellRing size={15} className="text-gold-deep" aria-hidden="true" /> Email me a reminder</p>
      <div className="mt-3 grid gap-2 sm:grid-cols-[1fr_1.3fr_auto]">
        <input className="field-input !py-2 text-sm" placeholder="Name (optional)" maxLength={80} autoComplete="name" aria-label="Name (optional)"
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reminder-name-input" />
        <input className="field-input !py-2 text-sm" type="email" required placeholder="Email address" autoComplete="email" aria-label="Email address"
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reminder-email-input" />
        <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={form.hp} onChange={(e) => setForm({ ...form, hp: e.target.value })} />
        <button type="submit" disabled={status.state === "loading"} className="btn btn-navy !py-2 text-sm disabled:opacity-60" data-testid="reminder-submit-button">
          {status.state === "loading" && <Loader2 size={15} className="animate-spin" />} Remind Me
        </button>
      </div>
      {status.state === "error" && <p className="mt-2 text-sm text-fire" role="alert" data-testid="reminder-error">{status.msg}</p>}
      <p className="mt-2 text-xs text-slate">We'll send a confirmation now and one reminder the morning before. Your email is used only for Foundation event updates and you can cancel anytime.</p>
    </form>
  );
};
